jQuery(function () {
	initMobileNav();
	initRetinaCover();
	initSlickCarousel();
	initMobileSlideNav();
	initFancybox();
	initPopups();
	initVideos();
	initQuality();
	initShine();
	initLoginForm();
	Page.init();
	initKnifeAnatomy();
	initRequestDemoForm();
	//VideoScroll.init();
});

function initLoginForm() {
	var Toast = Swal.mixin({
		toast: true,
		position: 'top-end',
		showConfirmButton: false,
		timer: 3000
	});

	jQuery('form.login-form').submit(function (e) {
		e.preventDefault();
		
		var $form = $(this);
		$form.addClass('wait');

		jQuery.ajax({
			type: 'GET',
			url: $form.attr("action"),
			beforeSend: function(xhr) {
				var username = $form.find('#username').val();
				var password = $form.find('#password').val();
				xhr.setRequestHeader("Authorization", "Basic " + window.btoa(username + ":" + password));
			},
			success: function () {
				window.location = "/portal";
			},
			error: function() {
				Toast.fire({
					icon: 'error',
					title: 'Login failed, please check your credentials.'
				});
			},
			complete: function() {
				$form.removeClass('wait');
			}
		});
	});
}

// video init
function initVideos() {
	jQuery('.play-btn').click(function() {
		var $this = jQuery(this);
		var $icon = $this.children('i');
		var video = $this.siblings('video')[0];

		if (video.paused) {
			video.play();
			$icon.addClass('icon-pause').removeClass('icon-play');
		} else {
			video.pause();
			$icon.addClass('icon-play').removeClass('icon-pause');
		}

		return false;
	});

	jQuery('.sound-btn').click(function () {
		var $this = jQuery(this);
		var $icon = $this.children('i');
		var video = $this.siblings('video')[0];

		if (video.muted) {
			video.muted = false;
			$icon.addClass('icon-volume-on').removeClass('icon-volume-mute');
		} else {
			video.muted = true;
			$icon.addClass('icon-volume-mute').removeClass('icon-volume-on');
		}

		return false;
	});
}

function initQuality() {
	jQuery('.quality-list li a').click(function () {
		var index = jQuery('.quality-list li a').index(this);
		var $textItems = jQuery('.quality .text-holder p');
		var $activeText = $textItems.eq(index);

		$textItems.addClass('hidden');
		$activeText.removeClass('hidden');

		return false;
	});
}

// popups init
function initPopups() {
	jQuery('.popup-info').contentPopup({
		mode: 'click'
	});
}

// lightbox init
function initFancybox() {
	jQuery('a.lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		margin: [50, 0],
		loop: false,
		infobar: false,
		slideShow: false,
		fullScreen: false,
		thumbs: false,
		toolbarCloseBtn: false,
		touch: false,
		afterLoad: function () {
			var instance = jQuery.fancybox.getInstance();
			var slider = jQuery('.fancybox-content .lightbox-slide');

			jQuery(window).trigger('resize');

			if (slider.hasClass('slick-initialized')) {
				jQuery('.fancybox-content .lightbox-slide').slick('refresh');
			}

			jQuery('.fancybox-content video')[0].play();

			instance.update();
			VideoScroll.refresh();
		}
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		menuDrop: '.navigation',
		hideOnClickOutside: true
	});
}

// mobile navigation init
function initMobileSlideNav() {
	var mobileNav = jQuery('.navigation');

	ResponsiveHelper.addRange({
		'..767': {
			on: function () {
				mobileNav.mobileSlideNav({
					slider: '> ul',
					listItems: 'li',
					opener: '> a',
					dropdown: '.drop',
					btnBackClass: 'btn-back',
					btnBackText: 'Back',
					activeClass: 'active-item',
					hasDropClass: 'has-drop',
					animSpeed: 500
				});
			}
		},
		'768..': {
			on: function () {
				mobileNav.each(function () {
					var navAPI = jQuery(this).data('MobileSlideNav');

					if (navAPI) {
						navAPI.destroy();
					}
				});
			}
		}
	});
}

function initRetinaCover() {
	jQuery('.bg-stretch').retinaCover();
}

function initShine(){
	jQuery('.imgShine').each(function(){
		var src = jQuery(this).find('img').attr('src');
		jQuery(this).css({
			'mask-image':'url('+src+')',
			'-webkit-mask-image':'url('+src+')',
		});
	});
}

// slick init
function initSlickCarousel() {
	jQuery('.slick-slider').slick({
		slidesToScroll: 1,
		rows: 0,
		slidesToShow: 7,
		arrows: false,
		dots: true,
		infinite: true,
		cssEase:'var(--ease-in-out)',
		autoplay:true,
		autoplaySpeed: 2000,
		dotsClass: 'slick-dots',
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 1,
			}
		}]
	});

	jQuery('.blockquote-slider').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"></button>',
		nextArrow: '<button class="slick-next"></button>'
	});

	jQuery('.mob-slider').each(function () {
		var holder = jQuery(this);
		var slider = holder.find('.lightbox-slide');
		var btnPrev = holder.find('.btn-prev');
		var btnNext = holder.find('.btn-next');
		var dots = holder.find('.knife-box > span');
		var activeClass = 'active';

		ResponsiveHelper.addRange({
			'..767': {
				on: function () {
					slider.slick({
						slidesToScroll: 1,
						rows: 0,
						fade: true,
						arrows: false
					});

					slider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
						dots.removeClass(activeClass);
						dots.eq(nextSlide).addClass(activeClass);
					});

					btnPrev.on('click', prevSlide);
					btnNext.on('click', nextSlide);
				}
			},
			'768..': {
				on: function () {
					if (slider.hasClass('slick-initialized')) {
						slider.slick('destroy');
					}

					btnPrev.off('click', prevSlide);
					btnNext.off('click', nextSlide);
				}
			}
		});

		function prevSlide(e) {
			e.preventDefault();

			slider.slick('slickPrev');
		}

		function nextSlide(e) {
			e.preventDefault();

			slider.slick('slickNext');
		}
	});
}

var Page = (function(){
	var root = document.documentElement;
	var win = jQuery(window);
	var scrollPos = 0;

	var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

	function init(){
		update();
		jQuery(window).resize(update);
		jQuery(window).scroll(update);
	}

	function loop(){
		update();
		requestAnimationFrame(loop);
	}

	function update(){
		scrollPos = win.scrollTop();

		if(scrollPos > 10){
			jQuery("body").addClass("scrolled");
		}else{
			jQuery("body").removeClass("scrolled");
		}

		var viewportClass = 'in-viewport';
		
		jQuery('section, section .container, footer').each(function(e){
			var p = percentageSeen(jQuery(this), 0);
			if(p > 10){
				jQuery(this).addClass(viewportClass);
			}else{
				jQuery(this).removeClass(viewportClass);
			}
		});
	}


	function percentageSeen (element, offset) {
		var viewportHeight = jQuery(window).height(),
		scrollTop = win.scrollTop() + (viewportHeight*offset),
		elementOffsetTop = element.offset().top,
		elementHeight = element.height();

		if (elementOffsetTop > (scrollTop + viewportHeight)) {
			return 0;
		} else if ((elementOffsetTop + elementHeight) < scrollTop) {
			return 100;
		} else {
			var distance = (scrollTop + viewportHeight) - elementOffsetTop;
			var percentage = distance / ((viewportHeight + elementHeight) / 100);
			//percentage = Math.round(percentage);
			return percentage;
		}
	}

	function isSeen(element){
		var viewportHeight = jQuery(window).height(),
			scrollTop = win.scrollTop(),
			elementOffsetTop = element.offset().top;

		var distance = (scrollTop + viewportHeight) - elementOffsetTop;
		return distance;
	}

	return {
		init:init,
		update:update,
	}
})();

var VideoScroll = (function(){
/*
	The encoding is VERY important to enable smooth scrubbing.

	Current workflow:
		Ideally compress video before these steps as compressing video after could change encoding.
*
*** Convert source mp4 to mov:
*		ffmpeg -i video.mp4 video.mov
*
*** Encode your mov to the optimal encoding format, and convert back to mp4 and/or webm
*		ffmpeg -i video.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p video.mp4
*		ffmpeg -i video.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p video.webm
*
*** Additional flag for rescaling
*	  -vf scale=960:-1

Good luck.
*/

	var frameNumber = 0;
	var idealFrame;
	var playbackConst = 300; // lower = faster
	var playbackExtend = 1.3; // make end earlier
	var vid, setHeight;

	var scrollTop;

	function init(){
		if(! jQuery('.popup-anatomy .video-holder video') ) return;
		vid = jQuery('.popup-anatomy .video-holder video')[0];
		setHeight = jQuery('.popup-anatomy .video-holder .set-height')[0];
		jQuery('.popup-anatomy .video-holder video')[0].addEventListener('loadedmetadata', function() {
			setHeight.style.height = Math.floor(vid.duration) * playbackConst + "px";
			loop();
		});
	}

	function loop(){
		if(jQuery('.fancybox-slide')){
			scrollTop = jQuery('.fancybox-slide').scrollTop();
			update();
		}
		requestAnimationFrame(loop);
	}

	function update(){
		if(!vid) return;
		if(!scrollTop) return;
		console.log(scrollTop);
		
		setHeight.style.height = Math.floor(vid.duration) * playbackConst + "px";

		var frameNumber = (scrollTop/playbackConst) * playbackExtend;
		vid.currentTime += (frameNumber - vid.currentTime)*0.4; // Try and smooth it a bit

		var playback = vid.currentTime / vid.duration;
		var quarter = Math.floor( ( playback * 4 ) % 4); 
		jQuery('.popup-anatomy').attr('playback', playback);
		jQuery('.popup-anatomy').attr('quarter', quarter);
		//if( vid.currentTime > vid.duration ) vid.currentTime = vid.duration;
	}
	function refresh(){
		init();
	}
	return {
		init:init,
		refresh:refresh,
	}
})();

function initKnifeAnatomy(){
	jQuery('.anatomy .btn').click(function(e) {
		e.preventDefault();
		jQuery(this).closest('.anatomy').addClass('show-video');
		return false;
	});
	jQuery('.anatomy video').on('ended',function(){
		jQuery(this).closest('.anatomy').removeClass('show-video');
		var video = jQuery(this)[0];

		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	});
}


function initRequestDemoForm() {

	$(function () {
		$("#demo-request-form").submit(function (e) {
			e.preventDefault();

			var $form = $(this);
			$form.find('.alert').hide();
			$form.find('.wait').fadeIn();

			$.ajax({
				type: 'POST',
				url: $form.attr("action"),
				data: $form.serialize(),
				contentType: 'application/x-www-form-urlencoded'
			})
			.done(function () {
				$form.fadeTo(500, 0, function () {
					$('#request-success').fadeIn();
				});
			})
			.fail(function () {
				$form.find('.alert.alert-danger').fadeIn();
			})
			.always(function () {
				$form.find('.wait').hide();
			});

			return false;
		});
	});
}